module.exports = __webpack_public_path__ + "static/b-a-1-after-dbf3eafd171ddcfb37123ca898e7bda7.jpg";